module.exports = __webpack_public_path__ + "static/angular-testing-header-8796a0048f4c4f103bcdb2ad5f10555f.png";